<template>
  <ul
    v-if="listErrors.length > 0"
    class="formulate-input-errors"
  >
    <li
      v-for="(error, index) in listErrors"
      :key="index"
      role="status"
      aria-live="assertive"
      class="formulate-input-error"
    >
      {{ error }}
    </li>
  </ul>
</template>

<script>
/**
 * Custom FormulateErrorList component that adds aria-live="assertive" to individual error messages
 * to ensure screen readers immediately announce form validation errors.
 */
export default {
  // Explicitly set the name for Vue Formulate to identify this component
  name: 'FormulateErrorList',
  // Set formulateComponent to true to identify this as a Formulate component
  formulateComponent: true,
  props: {
    errors: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    listErrors () {
      return this.errors.filter(e => e)
    }
  },
  // Force aria-live to be assertive after component mount
  mounted() {
    this.$nextTick(() => {
      if (this.$el) {
        const items = this.$el.querySelectorAll('.formulate-input-error');
        items.forEach(item => {
          item.setAttribute('aria-live', 'assertive');
        });
      }
    });
  },
  // Update aria-live after update as well
  updated() {
    this.$nextTick(() => {
      if (this.$el) {
        const items = this.$el.querySelectorAll('.formulate-input-error');
        items.forEach(item => {
          item.setAttribute('aria-live', 'assertive');
        });
      }
    });
  }
}
</script>
